export default __webpack_public_path__ + "static/media/sports1.ef1119e5.png";